import React from 'react'
import { reduxForm } from 'redux-form'

import Card from '../../Shared/Card'
import Button from '../../Shared/Button'
import FormError from '../../Shared/Forms/FormError'
import Input from './Input'

import styles from './Run.module.css'

const FORM_NAME = 'run-action'

const Form = function RunActionForm({
  action,
  handleSubmit,
  history,
  submitting,
  error,
  presetValues,
}) {
  if (!presetValues) {
    presetValues = {}
  }

  const inputs = (action.details.inputs || []).filter(
    input => !presetValues[input.id]
  )

  return (
    <Card
      component="form"
      onSubmit={handleSubmit}
      actions={
        <>
          <Button text type="button" onClick={history.goBack}>
            Back
          </Button>
          <Button icon="run" loading={submitting} loadingText="Running...">
            Run Now
          </Button>
        </>
      }
    >
      <h1>{action.name}</h1>
      <div className={styles.inputs}>
        {inputs.map(input => (
          <Input key={input.id} input={input} />
        ))}
      </div>
      {error && <FormError>{error}</FormError>}
    </Card>
  )
}

export default reduxForm({
  form: FORM_NAME,
})(Form)
